import _ from 'lodash';
import {createSelector} from 'reselect';
import {findEntryDescForModel} from 'module/edesc/EntryDescUtil';
import {PropID} from 'module/Properties/enum/PropID';
import {selPropGenString} from 'module/Properties/selector/selPropGen';
import {selEntryDescById} from 'module/edesc/selector/EntryDescSelector';

export const selFavDefault = createSelector(
	selPropGenString(PropID.eventDialog_favDefault),
	selEntryDescById,
	(favDefault, byId) => {
		const str = favDefault || '';
		const arrArr = str.split(',').map(x => x.split('/'));
		return _.compact(arrArr.map(
			([bookingType, hourCategory]) => {
				const ed = findEntryDescForModel(byId, {
					bookingType,
					hourCategory,
				});
				return ed && ed.id;
			},
		))
	},
)